import spacing from './spacing';

export default {
  backgroundColor: '#ffffff',
  borderRadius: '9px',
  border: '1px solid #F5F5F5',
  boxShadow: '0px 2px 4px rgba(3, 55, 103, 0.1)',
  padding: `${spacing?.(2)}`
};
